import StructuredValues from '../../../scripts/structured-values'
import roundTo from 'round-to'
import celsiusToFahrenheit from '../../../util/celsius-to-fahrenheit'
import getHeatIndex from '../../../util/get-heat-index'
import fahrenheitToCelsius from '../../../util/fahrenheit-to-celsius'
import { isUndefined } from 'underscore'

const Sidebar_TS = new StructuredValues([
  {
    key: 'temperature',
    label: 'Temp',
    value: item => {
      return `${window.celsiusToUserTemp(item.last_temp, 1)}&deg;${currentUser.temp_pref}`;
    }
  },
  {
    key: 'humidity',
    label: 'Humidity',
    value: item => {

      const last_humidity = parseFloat(item.last_humidity);
      return `${roundTo(last_humidity, 1)}%`;

    }
  },
  {
    key: 'heat_index',
    label: 'Heat Index',
    value: item => {

      const temp = celsiusToFahrenheit(item.last_temp);
      const humidity = item.last_humidity;

      const heatIndexF = getHeatIndex(temp, humidity);

      if(window.getUserTempPref() === 'C') {
        return `${fahrenheitToCelsius(heatIndexF, 1)}&deg;${currentUser.temp_pref}`;
      } else {
        return `${roundTo(heatIndexF, 1)}&deg;${currentUser.temp_pref}`;
      }

    }
  },
  {
    key: 'dew_point',
    label: 'Dewpoint',
    value: item => {
      return window.getDewpoint(item.last_humidity, item.last_temp);
    }
  },
  {
    key: 'battery',
    label: 'Battery',
    value: item => {

      if(!isUndefined(item.last_battPct)) {
        return window.getBatteryIconPct(item.last_battPct);
      }

      return window.getBatteryIcon(item.last_voltage);
    }
  },
  {
    key: 'rssi',
    label: 'Signal Strength',
    value: item => {
      return window.getSignalStrengthIcon(item.rssi);
    }
  },
]);

Sidebar_TS.rowTemplate(`
<div class="sidebar-sensor__stat" data-for="%key%">
  <div class="sidebar-sensor__label">%label%</div>
  <div class="sidebar-sensor__value">
    <span class="value-wrapper">%value%</span>
  </div>
</div>
`);

export default Sidebar_TS
